module.exports = __webpack_public_path__ + "img/Compact-FR_Overview-ECCsmall_1.8a55e17f.jpg";